import React, { useState, useEffect } from 'react';
import { useNotify } from "react-admin";
import Switch from '@material-ui/core/Switch';
import * as apiClient from "../common/apiClient";
import { makeStyles } from '@material-ui/core/styles';
import CountBlock from "./CountBlock";
import HolidayList from "./HolidayList";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CustomCalendar from './customcalender/CustomCalendar';
import { Create, SimpleForm, TextInput, BooleanInput, DateInput, NumberInput, required, ReferenceInput, AutocompleteInput, SelectInput } from 'react-admin';
import { Authorizer } from "../common/Authorizer";
import { debug } from 'console';
const useStyles = makeStyles({
    flexCenter: { display: 'flex', justifyContent: "center", alignContent: "center", flexWrap: "wrap" },
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' },
    locationPrompt: {
        padding: "10px",
        backgroundColor: "#ffcc00",
        color: "#333",
        borderRadius: "5px",
        marginBottom: "10px",
        textAlign: "center"
    },
    button: {
        marginTop: '10px',
        padding: '5px 10px',
        backgroundColor: '#f4a261',
        color: '#fff',
        border: 'none',
        cursor: 'pointer'
    }
});
const Dashboard = (props) => {
    const propsObj = Authorizer({
    ...props
    });

    console.log(propsObj);

    let isAdmin = false;
    let RoleTypeId = localStorage.getItem("RoleTypeId");
    if (RoleTypeId != null && RoleTypeId == "1") {
        isAdmin = true;
    }
     console.log("Dashboard Permissions", RoleTypeId);
    const [db, setdb] = useState([]);
    const [fetchingAttedanceStatus, setFetchingAttedanceStatus] = useState(true);
    const [attType, setAttType] = useState("");
    const [workLocation, setWorkLocation] = useState("");
    const [attOnOff, setattOnOff] = useState(false);
    const [holiday, setHoliday] = useState([]);
    const [isLocationEnabled, setIsLocationEnabled] = useState<any>(null);
    const [showLocationPrompt, setShowLocationPrompt] = useState(false);
    const [latitude, setLatitude] = useState<number | null>(null);  // Store latitude
    const [longitude, setLongitude] = useState<number | null>(null);  // Store longitude
    const [refData, setRefData] = useState<any>(null);  // Store longitude
    const [sourceTypeId, setSourceTypeId] = useState<any>(null);  // Store longitude
    const [refCustomerId, setRefCustomerId] = useState<any>(null);
    const [employeeId, setEmployeeId] = useState<any>(null);
    const [dashboardOfEmp, setDashboardOfEmp] = useState<any>([]);

    const notify = useNotify();
    const styles = useStyles({});

    const loadDashboard = () => {
        let userid = localStorage.getItem("userId");
        apiClient.get_dashboard(userid).then(res => {
            setdb(res);
        }).catch(err => {
            console.log(err);
        });
    }

    const GetDashboardHoliday = () => {
        apiClient.GetDashboardHoliday().then(res => {
            setHoliday(res);
        }).catch(err => {
            console.log(err);
        });
    }
    useEffect(() => {
        if (RoleTypeId) {
            loadSourceTypes();
        }
    }, [RoleTypeId]);

const [sourceTypeChoices, setSourceTypeChoices] = useState([] as any[]);

useEffect(() => {
    if (RoleTypeId) {
        loadSourceTypes();
    }
}, [RoleTypeId]);

const loadSourceTypes = () => {

    console.log("RoleTypeId =>", RoleTypeId);

    apiClient.getLookupSourceType(Number(RoleTypeId))
        .then((res: any) => {

            console.log("FULL API Response =>", res);

            let data: any[] = [];

            // CASE 1: Direct array
            if (Array.isArray(res)) {
                data = res;
            }

            // CASE 2: Axios style response
            else if (Array.isArray(res?.data)) {
                data = res.data;
            }

            // CASE 3: MSSQL recordset response
            else if (Array.isArray(res?.recordset)) {
                data = res.recordset;
            }

            // CASE 4: Nested recordset
            else if (Array.isArray(res?.data?.recordset)) {
                data = res.data.recordset;
            }

            console.log("FINAL ARRAY =>", data);

            setSourceTypeChoices(data);

        })
        .catch((err: any) => {
            console.log(err);
            setSourceTypeChoices([]);
        });
};
     const handleAttendance = (event) => {
        if (!isLocationEnabled) {
            notify("Please enable location to mark attendance", "warning");
            setShowLocationPrompt(true); // Show prompt to enable location
            return;
        }
        if (workLocation === null || workLocation === "") {
            notify("Please Select Work location", "warning");
            return;
        }
        if (attType === "ATT_END" && window.confirm('Do you really want to end your working?')) {
            updateAttedance();
        }
        if (attType === "ATT_START" && window.confirm('Do you really want to Start your working?')) {
            updateAttedance();
        }
    }

    const updateAttedance = () => {
        setFetchingAttedanceStatus(true);
        let userid = localStorage.getItem("userId");
        let formBody = {
            userId: userid,
            attType: attType,
            location: workLocation,
            latitude: latitude,  // Add latitude
            longitude: longitude  // Add longitude
        }
        apiClient.updateAttendance(formBody).then(res => {
            notify(res[0].Msg)
            loadAttendance();
        }).catch(err => {
            console.log(err);
        });
    }

    const loadAttendance = () => {
        setFetchingAttedanceStatus(true);
        let userid = localStorage.getItem("userId");
        apiClient.get_attendancestatus(userid).then(res => {
            setAttType(res[0].Msg);
            setWorkLocation(res[0].location)
            if (res[0].Msg === 'ATT_START') {
                setattOnOff(false)
            }
            if (res[0].Msg === 'ATT_END') {
                setattOnOff(true)
            }
            setFetchingAttedanceStatus(false);
        }).catch(err => {
            console.log(err);
        });
    }
    
        const loadDashboardOfEmp = () => {

        
        apiClient.getDashboardOfEmp().then(res => {
            setDashboardOfEmp(res);
        }).catch(err => {
            console.log(err);
        });
    }

    const loadRefData = () => {

        let userid = localStorage.getItem("userId");
        let emprefcustID = 0;
        if (sourceTypeId == 219 || sourceTypeId == 218  ) {
            emprefcustID = refCustomerId;
        }
        if (sourceTypeId == 216  || sourceTypeId ==217) {
            emprefcustID = employeeId;
        }
        if(sourceTypeId==220)
        {
            setRefData([]);
            return;
        }

        if ((emprefcustID == null || emprefcustID == 0) && (sourceTypeId != 221 && sourceTypeId != 222)) {
            alert("Please select input")
            return;
        }
        apiClient.get_dashboardOfRMREF(userid, sourceTypeId, emprefcustID).then(res => {
            setRefData(res);
        }).catch(err => {
            console.log(err);
        });
    }


    // Function to check if location is enabled
    const checkLocationPermission = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setIsLocationEnabled(true);  // Location is enabled
                    setLatitude(position.coords.latitude);  // Store latitude
                    setLongitude(position.coords.longitude);  // Store longitude
                    setShowLocationPrompt(false); // Hide prompt
                },
                (error) => {
                    setIsLocationEnabled(false);  // Location is not enabled
                    setShowLocationPrompt(true);  // Show prompt to enable location
                }
            );
        } else {
            setIsLocationEnabled(false); // Geolocation not supported
            setShowLocationPrompt(true); // Show prompt
        }
    }

    // Function to recheck location permission
    const recheckLocationPermission = () => {
        checkLocationPermission();  // Recheck the location permission
        notify("Rechecked location permission.");
    }

    useEffect(() => {
        checkLocationPermission();  // Check for location permission on component mount
        loadDashboard();
        loadAttendance();
        GetDashboardHoliday();
        loadDashboardOfEmp();

    }, []);

    return (
        <SimpleForm toolbar={null}>
            <div style={{ width: "100%" }}>
                {showLocationPrompt && (
                    <div className={styles.locationPrompt}>
                        <strong>Location Permission is required to mark attendance. Please enable location services in your browser.</strong>
                        <button
                            className={styles.button}
                            onClick={recheckLocationPermission}
                        >
                            Recheck Location
                        </button>
                        <br />
                        <small>
                            You can enable location services in your browser settings.
                        </small>
                    </div>
                )}

                {!fetchingAttedanceStatus && (
                    <div style={{ display: "flex", marginTop: "6px", padding: "6px", fontSize: "12px", color: "blue", border: "1px solid lightgray" }}>
                        {attType !== "ATT_DONE" && <div>Mark {attType === 'ATT_START' ? ' In ' : ' Out '} Attendance  {attType === 'ATT_END' ? '. You are working from ' : ""}</div>}
                        {attType !== "ATT_DONE" && (
                            <div style={{ paddingLeft: 10 }}>
                                <select
                                    style={{ height: 30 }}
                                    onChange={(event) => setWorkLocation(event.target.value)}
                                    disabled={attType === "ATT_END" || attType === "ATT_DONE"}
                                >
                                    <option value="" selected={workLocation === null || workLocation === ""}>Select Work Location</option>
                                    <option value="WFH" selected={workLocation === "WFH"}>WFH</option>
                                    <option value="WFO" selected={workLocation === "WFO"}>WFO</option>
                                    <option value="WFF" selected={workLocation === "WFF"}>WFF</option>
                                </select>
                            </div>
                        )}
                        {attType !== "ATT_DONE" && (
                            <div>
                                <FormControlLabel
                                    value="start"
                                    control={<Switch color="primary" checked={attOnOff} onChange={(event) => handleAttendance(event)} />}
                                    label={attType === "ATT_START" ? "Start Your Day" : "End Your Working"}
                                    labelPlacement="start"
                                />
                            </div>
                        )}
                    </div>
                )}




                <div className={styles.flexCenter}>
                    {db && db.map((item: any, index: number) => {
                        return (
                            <div key={index}>
                                <CountBlock title={item.Descriptions} value={item.TotalCount} icon={item.IconUrl} />
                            </div>
                        )
                    })}
                </div>
               
               
               {dashboardOfEmp.length>0 && <div className={styles.flex} style={{ margin: 30 }}>
                    <div style={{width:"50%"}} >
                        <div style={{  backgroundColor: '#1976d2',
                            color: '#fff', }}><h4 style={{ textAlign: "center" }}>Happy Birth Day</h4></div>
                             <div dangerouslySetInnerHTML={{ __html: dashboardOfEmp[0].EmployeeDOBHTML }} />
                        
                    </div>
                    <div style={{ paddingLeft: 30 ,width:"50%" }}>
                        <div style={{  backgroundColor: '#1976d2',
                            color: '#fff', }}> <h4 style={{ textAlign: "center" }}>Happy Work Anniversary</h4></div>
                             <div dangerouslySetInnerHTML={{ __html: dashboardOfEmp[0].EmployeeDOAHTML }} />
                        
                    </div>
                </div>}

               
                <div style={{ margin: 30 }}
                >
                    <div style={{  backgroundColor: '#1976d2',
                            color: '#fff', }}>
                        <h4 style={{ textAlign: "center"  }}>Policy Due and Revenue Statistics</h4>
                        <hr />
                    </div> 
                    <div
                        className="filter-column"
                        style={{
                            display: 'flex',
                            gap: '1rem',
                            alignItems: 'flex-start',
                            width: "50%"

                        }}
                    >
                        <SelectInput
                            label="Source Type"
                            source="sourceTypeId"
                            choices={sourceTypeChoices}
                            optionText="name"
                            optionValue="id"
                            variant="outlined"
                            onChange={(event) => {
                                setSourceTypeId(event.target.value);
                            }}
                        />
                        
                        {sourceTypeId == 219 && <ReferenceInput
                            perPage={500}
                            sort={{ field: 'code', order: 'ASC' }}
                            validate={[required()]}
                            filterToQuery={(searchText) => ({ 'name~like': searchText })}
                            label="Ref Customer"
                            source="refCustomerId2"
                            reference="ref-customers"
                            onChange={(data) => { setRefCustomerId(data); }}
                            fullWidth={true} 
                            filter={{ typeId: 214 }}
                        >
                            <AutocompleteInput
                                optionText="name"
                                variant="outlined"
                                shouldRenderSuggestions={(val) => val && val.trim().length >= 1}
                            />
                        </ReferenceInput>
                        }
                        {sourceTypeId == 218 && <ReferenceInput
                            perPage={500}
                            sort={{ field: 'code', order: 'ASC' }}
                            validate={[required()]}
                            filterToQuery={(searchText) => ({ 'name~like': searchText })}
                            label="Ref Customer"
                            source="refCustomerId2"
                            reference="ref-customers"
                            onChange={(data) => { setRefCustomerId(data); }}
                            fullWidth={true}
                            filter={{ typeId: 215 }}
                        >
                            <AutocompleteInput
                                optionText="name"
                                variant="outlined"
                                shouldRenderSuggestions={(val) => val && val.trim().length >= 1}
                            />
                        </ReferenceInput>
                        }
                        {sourceTypeId == 216 && <ReferenceInput
                            perPage={500}
                            sort={{ field: 'code', order: 'ASC' }}
                            validate={[required()]}
                            filterToQuery={(searchText) => ({ 'name~like': searchText })}
                            label="Employee"
                            source="employeeId"
                            reference="employees"
                            fullWidth={true}
                            onChange={(data) => { setEmployeeId(data); }}
                            filter={{ typeId: 98 }}
                        >
                            <AutocompleteInput
                                optionText="name"
                                variant="outlined"
                                shouldRenderSuggestions={(val) => val && val.trim().length >= 1}
                            />
                        </ReferenceInput>
                        }

                        {sourceTypeId == 217 && <ReferenceInput
                            perPage={500}
                            sort={{ field: 'code', order: 'ASC' }}
                            validate={[required()]}
                            filterToQuery={(searchText) => ({ 'name~like': searchText })}
                            label="Employee"
                            source="employeeId"
                            reference="employees"
                            fullWidth={true}
                            onChange={(data) => { setEmployeeId(data); }}
                            filter={{ typeId: 103 }}

                        >
                            <AutocompleteInput
                                optionText="name"
                                variant="outlined"
                                shouldRenderSuggestions={(val) => val && val.trim().length >= 1}
                            />
                        </ReferenceInput>
                        }

                        {(employeeId != null || refCustomerId != null  || sourceTypeId == 221|| sourceTypeId == 222 )   && <button
                            type="button"
                            onClick={() => {
                                loadRefData();
                            }}
                            style={{
                                height: '40px',
                                padding: '0 16px',
                                backgroundColor: '#1976d2',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '2px',
                                cursor: 'pointer',
                                marginTop: 0
                            }}
                        >
                            Load
                        </button>
                        }
                    </div>
                    {refData && refData.length > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                            <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: refData[0].RMOutPut }} />
                            {/* <div dangerouslySetInnerHTML={{ __html: refData[0].REFOutPut }} style={{ paddingLeft: 30 }} /> */}
                        </div>
                    )}
                </div>


                <div className={styles.flex} style={{ margin: 30 }}>
                    <div >
                        <div style={{  backgroundColor: '#1976d2',
                            color: '#fff', }}><h4 style={{ textAlign: "center" }}>Attendance</h4></div>
                        <CustomCalendar />
                    </div>
                    <div style={{ paddingLeft: 30 }}>
                        <div style={{  backgroundColor: '#1976d2',
                            color: '#fff', }}> <h4 style={{ textAlign: "center" }}>Holiday Details</h4></div>
                        {holiday && <HolidayList data={holiday} />}
                    </div>
                </div>
            </div>
        </SimpleForm>
    );
}

export default Dashboard;
